import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PreventaPage } from './shared/preventa/preventa.page';
import { LoginGuard } from './core/guards/login.guard';

const routes: Routes = [

  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  {
    path: 'inicio',
    loadChildren: () => import('./pages/inicio/inicio.module').then(m => m.InicioPageModule)
  },
  { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule) },
  {
    path: 'home/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8/:id9/:id10/:id11/:id12/:id13/:id14/:id15',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  { path: 'producto', loadChildren: () => import('./pages/producto/producto.module').then(m => m.ProductoPageModule) },
  { path: 'producto/:id1', loadChildren: () => import('./pages/producto/producto.module').then(m => m.ProductoPageModule) },
  { path: 'producto/:pais', loadChildren: () => import('./pages/producto/producto.module').then(m => m.ProductoPageModule) },
  { path: 'producto/:pais/:id1', loadChildren: () => import('./pages/producto/producto.module').then(m => m.ProductoPageModule) },
  {
    path: 'cart',
    loadChildren: () => import('./pages/cart/cart.module').then(m => m.CartPageModule)
  },
  // { path: '**', redirectTo: 'inicio', pathMatch: 'full' },
  { path: 'home/:pais', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule) },
  {
    path: 'home/:pais/:id1/:id2/:id3/:id4/:id5/:id6/:id7/:id8/:id9/:id10/:id11/:id12/:id13/:id14/:id15',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'flags',
    loadChildren: () => import('./pages/flags/flags.module').then(m => m.FlagsPageModule)
  },
  {
    path: 'solutionguide',
    loadChildren: () => import('./pages/solutionguide/solutionguide.module').then(m => m.SolutionguidePageModule)
  },
  {
    path: 'terminos',
    loadChildren: () => import('./pages/ofertas/ofertas.module').then( m => m.OfertasPageModule)
    // loadChildren: () => import('./pages/terminos/terminos.module').then(m => m.TerminosPageModule)
  },
  {
    path: 'suscripcion',
    loadChildren: () => import('./pages/suscripcion/suscripcion.module').then(m => m.SuscripcionPageModule)
  },

  {
    path: 'select',
    loadChildren: () => import('./pages/select/select.module').then(m => m.SelectPageModule)
  },
  {
    path: 'select/:pais',
    loadChildren: () => import('./pages/select/select.module').then(m => m.SelectPageModule)
  },
  {
    path: 'intro',
    loadChildren: () => import('./pages/intro/intro.module').then( m => m.IntroPageModule)
  },
  {
    path: 'prime/:pais',
    loadChildren: () => import('./pages/prime/prime.module').then( m => m.PrimePageModule)
  },
  {
    path: 'preventa',
    component: PreventaPage
  },
  // {
  //   path: 'solutionguide/:pais',
  //   loadChildren: () => import('./solutionguide/solutionguide.module').then(m => m.SolutionguidePageModule)
  // },
  // {
  //   path: 'flags',
  //   loadChildren: () => import('./flags/flags.module').then( m => m.FlagsPageModule)
  // },
  {
    path: 'success',
    loadChildren: () => import('./pay/success/success.module').then( m => m.SuccessPageModule)
  },
  {
    path: 'failure',
    loadChildren: () => import('./pay/failure/failure.module').then( m => m.FailurePageModule)
  },
  {
    path: 'pending',
    loadChildren: () => import('./pay/pending/pending.module').then( m => m.PendingPageModule)
  },
  {
    path: 'review',
    loadChildren: () => import('./pay/review/review.module').then( m => m.ReviewPageModule)
  },

  {
    path: 'nuevascolecciones',
    loadChildren: () => import('./pages/nuevascolecciones/nuevascolecciones.module').then( m => m.NuevascoleccionesPageModule)
  },
  {
    path: 'ofertas',
    loadChildren: () => import('./pages/ofertas/ofertas.module').then( m => m.OfertasPageModule)
  },
  {
    path: 'tienda',
    loadChildren: () => import('./pages/tienda/tienda.module').then( m => m.TiendaPageModule)
  },
  {
    path: 'tienda/:pais',
    loadChildren: () => import('./pages/tienda/tienda.module').then( m => m.TiendaPageModule)
  },
  {
    path: 'blackfriday',
    loadChildren: () => import('./pages/blackfriday/blackfriday.module').then( m => m.BlackfridayPageModule)
  },
  {
    path: 'prime',
    loadChildren: () => import('./pages/prime/prime.module').then( m => m.PrimePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/panel-adminitrativo/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/panel-adminitrativo/dashboard/dashboard.module').then( m => m.DashboardPageModule),
    canActivate: [
      LoginGuard
    ]
  },
  { path: '**', redirectTo: 'inicio', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
